import { Col, Row, Spin } from 'antd';
import { CardTheme } from '../../../components/card';
import { StyledContainer } from '../../../components/container/styles';
import { TextLarge } from '../../../components/text';
import { RenderForm } from '../../../components/forms';
import { FORM_CUSTOMER_DATA, FORM_PRODUCT_DATA } from './form';
import { ButtonTheme } from '../../../components/buttons';
import { useGetRegViewList } from './hooks/useGetRegViewList';
import React from 'react';

export const RegistrationView = () => {
  const {
    control,
    getValues,
    setValue,
    mobileBrandList,
    channelBuyList,
    goBack,
    LoadingWarrantyView,
  } = useGetRegViewList();

  return (
    <Spin spinning={LoadingWarrantyView}>
      <StyledContainer>
        <TextLarge text="ดูข้อมูลทะเบียนสินค้า" />
        <Row gutter={16}>
          <Col span={14}>
            <CardTheme>
              <TextLarge text="ลูกค้าลงทะเบียนรับประกัน" />
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_CUSTOMER_DATA()}
              />
            </CardTheme>
          </Col>
          <Col span={10}>
            <CardTheme>
              <TextLarge text="สินค้าลงทะเบียนรับประกัน" />
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_PRODUCT_DATA({ mobileBrandList, channelBuyList })}
              />
            </CardTheme>
          </Col>
        </Row>
        <Row gutter={16} justify="space-between" align="middle" style={{ marginTop: '2%' }}>
          <Col>
            <ButtonTheme useFor="BACK" title="ย้อนกลับ" onClick={goBack} />
          </Col>
        </Row>
      </StyledContainer>
    </Spin>
  );
};
